<script lang="ts" setup>
import { useRouter } from 'vue-router';

import AppHeader from '@exchange/layouts/app-header/AppHeader.vue';
import HeaderMobile from '@exchange/layouts/app-header/HeaderMobile.vue';
import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';

import InfoTile from './components/InfoTile.vue';

const router = useRouter();
const { isXS } = useMQBreakpoints();

const goBack = () => {
  router.go(-1);
};
</script>

<template>
  <div class="container-404">
    <header-mobile
      v-if="isXS"
      @go-back="goBack"
    >
      <template #top-content>
        <div class="container-404__title">{{ $t('views.404.name') }}</div>
      </template>
    </header-mobile>
    <app-header v-else />
    <div class="container-404__content">
      <info-tile class="container-404__info">
        <template
          v-if="!isXS"
          #title
        >
          <div class="container-404__title">{{ $t('views.404.name') }}</div>
        </template>
        <template #text>
          <div class="container-404__text">{{ $t('views.404.description') }}</div>
        </template>
      </info-tile>
      <x-button
        class="container-404__go-back"
        variant="primary"
        :text="$t('views.404.goBack')"
        @click="goBack"
      />
    </div>
  </div>
</template>

<style lang="scss">
.container-404 {
  flex: 1 1 auto;

  &__title {
    color: rgb(var(--v-theme-text-primary));
    font-size: var(--font-size-xl);
    font-weight: var(--font-weight-bold);
    letter-spacing: normal;
    text-transform: uppercase;
  }

  &__content {
    z-index: var(--content-z-index);
    display: flex;
    max-width: 100%;
    flex: 1 1 auto;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
    transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
}
</style>
./components/InfoTile.vue
